export default __webpack_public_path__ + "static/media/calendarIcon.32a68d66.svg";